// Pins this system offers in PinnedBar.
const pins = {
  pinnable: [
  { id: 'hp',            labelKey: 'pinned.hp' },
  { id: 'inspiration',   labelKey: 'pinned.inspiration' },
  { id: 'concentration', labelKey: 'pinned.concentration' },
  { id: 'conditions',    labelKey: 'pinned.conditions' },
  { id: 'deathSaves',    labelKey: 'pinned.deathSaves' },
  ],
};

export default pins;
